// Set by the backend email-activation endpoint on the redirect that follows a successful activation.
export const ACCOUNT_ACTIVATED_PARAM = 'account_activated';

export const isActivationLanding = (): boolean =>
  new URLSearchParams(window.location.search).get(ACCOUNT_ACTIVATED_PARAM) === '1';
